import Select from "react-select";
import { React, useEffect, useState, useReducer } from "react";
import OrderTakerNavbarAllPAges from "../../Components/OrderTakerNavbarAllPAges";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { IoFastFoodOutline } from "react-icons/io5";
import Loading from "../../Components/Loading";
import { useNavigate } from "react-router-dom";
import { IoClose } from "react-icons/io5";
import { FaShoppingCart } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";
import moment from "moment";
import { MdPreview } from "react-icons/md";
import { useLocation } from "react-router-dom";
import CashPos from "./CashPOS"

const TakeOrder = ({ hideNavbar }) => {
  const location = useLocation();
  const orderNo = location?.state;
  const [selTable, setSelTable] = useState("");
  const [itemsPopup, setItemsPopUp] = useState(false);
  const BASEURL = process.env.REACT_APP_BASEURL;
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const divisionState = useSelector((state) => state.changeDivision);
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const [category, setcategory] = useState([]);
  const [itemdetails, setItemdetails] = useState([]);
  const [selcategory, setselcategory] = useState("");
  const [allTablesList,setAllTablesList] = useState([])
  const [tables, setTables] = useState([]);
  const [areaList, setAreaList] = useState([])
  const [selAreaName,setSelAreaName] = useState("")
  const [selAreaId,setSelAreaId] = useState("")
  const [isloading, setisloading] = useState(true);
  const [table, setistable] = useState(true);
  const [ShowTable, setShowTable] = useState(false);
  const navigate = useNavigate();
  const userState = useSelector((state) => state.changeTheState.user);
  const loggedInUser = userState?.emailId?.split("@")[0]?.toUpperCase();
  const [clientsList, setClientlist] = useState([]);
  const [paymodeList, setPayModeList] = useState([]);
  const [newOrderNo, setNewOrderNo] = useState("");
  const [selClientName, setSelClientName] = useState("");
  const [selClientCode, setSelClientCode] = useState("");
  const [selClientEmail, setSelclientEmail] = useState("");
  const [selClientPhone, setSelClientPhone] = useState("");
  const [selClientCountry, setSelClientCountry] = useState("");
  const [selClientCity, setSelClientCity] = useState("");
  const [selPaymode, setSelPayMode] = useState("");
  const [vatPerc, setVatPerc] = useState("");
  const [currency, setCurrency] = useState("");
  const [notes, setNotes] = useState("");
  const [date, setDate] = useState(new Date().toISOString());
  const [selClientAddress, setSelClientAddress] = useState("");
  const [vatAmount, setVatAmount] = useState("");
  const [AmountExclVat, setAmountExclVat] = useState("");
  const [AmountInclVat, setAmountInclVat] = useState("");
  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString(),
  );
  const [itemsList, setItemsList] = useState([]);
  const [viewPopUp, setViewPopUp] = useState(false);
  const [selectedItem, setSelectedItem] = useState({});
  const [orderPopUp, setOrderPopUp] = useState(false);
  const [orderHeaders, setOrderHeaders] = useState([]);
  const [search, setSearch] = useState("");
  const [startdate, setstartdate] = useState("");
  const [enddate, setEnddate] = useState("");
  const formattedDate = moment.utc(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
  const [selType, setSelType] = useState("");
  const [showCashPos,setShowCashPos] = useState(false)

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Filters for Orders Pop Up
  const filtOrders = orderHeaders.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);
    const sDate = item.ENQUIRYDATE;
    const eDate = item.ENQUIRYDATE;

    if (searchData.length === 0 && !startdate && !enddate) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["CLIENT NAME", "ENQUIRYNO", "MODEOFPAY", "PONOTES"].some(
        (key) => {
          const columnValue = String(item[key]).toLowerCase();
          return columnValue.includes(term);
        },
      );
    });

    const dateMatch =
      (!startdate || sDate >= startdate) && (!enddate || eDate <= enddate);

    return textMatch && dateMatch;
  });

  const handleRowClick = (item) => {
    setItemsList((prevItems) => {
      if (
        prevItems.some(
          (selected) =>
            selected.ITEMCODE === item.ITEMCODE &&
            selected.ITEMDESCRIPTION === item.ITEMDESCRIPTION,
        )
      ) {
        // Remove the item if it's already selected
        return prevItems.filter(
          (selected) =>
            selected.ITEMCODE !== item.ITEMCODE ||
            selected.ITEMDESCRIPTION !== item.ITEMDESCRIPTION,
        );
      } else {
        // Calculate VAT and POITEMAMOUNT
        const vatAmount = (Number(item.ITEMRATE) * Number(vatPerc)) / 100;
        const amtexclVat = item.ITEMRATE;
        const amtinclVat =
          item.VATABLE === 1
            ? Number(item.ITEMRATE) + vatAmount
            : item.ITEMRATE;
        // Add the item if it's not already selected
        return [
          ...prevItems,
          {
            ...item,
            ITEMQTY: 1,
            PROPERTY: "MILD",
            POITEMAMOUNT: amtinclVat,
            ITEMRATE: amtexclVat,
            VAT: item.VATABLE,
          },
        ];
      }
    });
  };

  const handleQuantityChange = (item, value) => {
    const updatedItems = itemsList.map((selected) => {
      if (
        selected.ITEMCODE === item.ITEMCODE &&
        selected.ITEMDESCRIPTION === item.ITEMDESCRIPTION
      ) {
        const quanity = item.ITEMQTY || 1;
        const itemRate = Number(item.ITEMRATE) / Number(quanity);
        const vatAmount = (Number(itemRate) * Number(vatPerc)) / 100;
        const amtexclVat = itemRate * value;
        const amtinclVat =
          item.VATABLE === 1
            ? (Number(itemRate) + vatAmount) * value
            : itemRate * value;
        return {
          ...selected,
          ITEMQTY: value,
          POITEMAMOUNT: amtinclVat,
          ITEMRATE: amtexclVat,
          VAT: item.VATABLE,
        };
      }
      return selected;
    });
    setItemsList(updatedItems);
  };

  const handleSpiceLevelChange = (item, value) => {
    const updatedItems = itemsList.map((selected) => {
      if (
        selected.ITEMCODE === item.ITEMCODE &&
        selected.ITEMDESCRIPTION === item.ITEMDESCRIPTION
      ) {
        return { ...selected, PROPERTY: value };
      }
      return selected;
    });
    setItemsList(updatedItems);
  };

  // console.log(itemsList);

  useEffect(() => {
    getNewEnqquiryNo();
    getALLTables();
    getAllCategories();
    getOrganizationDetails();
    getListOfClients();
    // getPayModes();
    getOrderHeaders();
  }, []);

  const getALLTables = () => {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=531&DIVISION=${divisionState}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        setAllTablesList(response?.data)
        const uniqueAreas = [
      ...new Map(
        response.data.map(item => [item.AREANAME, item])
      ).values()
        ];
        console.log(uniqueAreas)
    setAreaList(uniqueAreas);
      })
      .catch((error) => {
        console.error("Error fetching Table details:", error);
      });
  };

  const getAllCategories = () => {
    axios
      // .get(`${BASEURL}/getallcategories`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=287`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setcategory(response.data);
        setisloading(false);
        setistable(false);
      })
      .catch((error) => {
        setisloading(false);
        setistable(false);
        console.error("Error fetching Main Categories:", error);
      });
  };

  const getItemDetails = (value) => {
    axios
      .get(
        // `${BASEURL}/getItemDetails`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=287&MAINCATEGORY=${value}`,
        // {
        //   category: value,
        // },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        const transformedData = response.data.map((item) => ({
          ITEMCODE: item.OM_ITEM_CODE,
          ITEMDESCRIPTION: item.OM_ITEM_DESCRIPTION,
          ITEMUOM: item.UOM,
          ITEMRATE: item.SELLINGPRICE,
          ...item, // Include other unchanged properties
        }));
        console.log(transformedData);
        setItemdetails(transformedData);
        setShowTable(true);
        setistable(false);
      })
      .catch((error) => {
        setistable(false);
        console.error("Error fetching List Of Items:", error);
      });
  };

  const getOrganizationDetails = () => {
    axios
      // .get(`${BASEURL}/getOrganizationDetails`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=689`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setVatPerc(response?.data?.[0]?.VATPERC);
        setCurrency(response?.data?.[0]?.BASECURRENCY);
        // setOrganisationDetails(response?.data?.[0]);
      })
      .catch((error) => {
        console.error("Error fetching List Of /getOrganizationDetails:", error);
      });
  };

  const getListOfClients = () => {
    axios
      // .get(`${BASEURL}/getListOfClients`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=685`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setClientlist(response.data);
      })
      .catch((error) => {
        console.error("Error fetching List Of /getListOfClients:", error);
      });
  };

  const getPayModes = () => {
    axios
      // .get(`${BASEURL}/getPayModes`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=18`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setPayModeList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching List Of /getPayModes:", error);
      });
  };

  const getOrderHeaders = () => {
    axios
      .get(
        // `${BASEURL}/getOrderHeaders?DIVISION=${divisionState}&CREATEDBY=${loggedInUser}`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=687&DIVISION=${divisionState}&CREATEDBY=${loggedInUser}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        setOrderHeaders(response.data);
      })
      .catch((error) => {
        console.error("Error fetching List Of Orders /getOrderHeaders:", error);
      });
  };

  const getOrderItems = (value) => {
    axios
      .get(
        // `${BASEURL}/getOrderItems?ENQUIRYNO=${value}`,
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=587&ENQUIRYNO=${value}`,

        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((response) => {
        console.log(response.data);
        setItemsList(response.data);
      })
      .catch((error) => {
        console.error("Error fetching List Of Items:", error);
      });
  };

  const getNewEnqquiryNo = () => {
    axios
      // .get(`${BASEURL}/getNewEnqquiryNo`, {
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=688`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessiontoken,
        },
      })
      .then((response) => {
        setNewOrderNo(response.data[0].NEXTPONO);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching List Of /getNewEnqquiryNo:", error);
      });
  };

  // *********************** Save *********************
  async function SaveHeader() {
    setisloading(true);
    try {
      const response = await axios.post(
        // `${BASEURL}/insertOrderHeaders`,
        `${BASEURL_GLOBAL}/globalSpHandler?spname=690&successstatus=true`,
        {
          SALESENQUIRYNO: Number(newOrderNo),
          SALESENQUIRYITEMSSERVICE: 1,
          CLIENTCODE: selClientCode,
          REFFROM: "",
          SALESENQUIRYDATE: formattedDate,
          SALESENQUIRYVEHICLE: "",
          DIVISION: divisionState ? divisionState : "",
          SALESENQUIRYNOTES: "",
          CREATEDBY: loggedInUser ? loggedInUser : "",
          CREATEDDATE: formattedDate,
          CREATEDTIME: currentTime ? currentTime : "",
          AMOUNTEXCVAT: AmountExclVat ? Number(AmountExclVat) : 0,
          VATAMOUNT: vatAmount ? Number(vatAmount) : 0,
          AMTOUNTINCLUSIVEVAT: AmountInclVat ? Number(AmountInclVat) : 0,
          CURRENCYCODE: currency ? currency : "",
          MODEOFPAY: "CASH",
          CLIENTNAME: selClientName ? selClientName : "",
          DELIVERYADDRESS: selClientAddress ? selClientAddress : "",
          CLIENTEMAIL: selClientEmail ? selClientEmail : "",
          CLIENTCOUNTRY: selClientCountry ? selClientCountry : "",
          CLIENTCITY: selClientCity ? selClientCity : "",
          CLIENTPHONENUMBER: selClientPhone ? selClientPhone : "",
          CARTNO: 0,
          DELIVERYPROVIDED: 1,
          DELIVERYROUTE: 0,
          DELIVERYCHARGES: 0,
          TABLENUMBER: selTable ? selTable : "",
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      );

      if (response.status === 201) {
        alert("Order Header Saved Successfully");
        setisloading(false);
      } else {
        alert(response.data.message);
        setisloading(false);
      }
    } catch (error) {
      setisloading(false);
      console.error(
        `Error while saving Order Headers /insertOrderHeaders`,
        error,
      );
      alert(error.response.data.message);
    }
  }

  async function SaveDetails() {
    setisloading(true);
    let successCount = 0;
    let successMessage = null;
    let errorCount = 0;
    let errorMessage = null;
    for (let index = 0; index < itemsList.length; index++) {
      const value = itemsList[index];
      try {
        const response = await axios.post(
          // `${BASEURL}/insertOrderItems`,
          `${BASEURL_GLOBAL}/globalSpHandler?spname=691&successstatus=true`,
          {
            SALESENQUIRYNO: Number(newOrderNo),
            SALESENQUIRYDATE: formattedDate,
            SERIALNO: Number(index),
            ITEMCODE: value.ITEMCODE,
            ITEMDESCRIPTION: value.ITEMDESCRIPTION,
            ITEMPROPERTY: value.PROPERTY,
            UOM: value.ITEMUOM,
            ITEMQTY: Number(value.ITEMQTY),
            ITEMRATE: Number(value.ITEMRATE),
            ITEMVAT: value.VAT,
            ITEMCURRENCY: currency,
            ITEMAMOUNT: Number(value.POITEMAMOUNT),
            DIVISION: divisionState ? divisionState : "",
            CREATEDBY: loggedInUser,
            CREATEDDATE: formattedDate,
          },
          {
            headers: {
              "auth-token": authToken,
              "session-token": sessiontoken,
            },
          },
        );

        if (response.status === 201) {
          successCount++;
          successMessage = response.data.message;
        } else {
          errorCount++;
          errorMessage = response.data.message;
        }
      } catch (error) {
        setisloading(false);
        console.error(
          `Error while Saving Details Of Order taking /insertOrderItems `,
          error,
        );
        errorCount++;
        errorMessage = error.response.data.message;
        // alert(error.response.data.message);
      }
    }
    setisloading(false);
    if (successCount == itemsList.length && successMessage) {
      alert("Order Details Saved Successfully");
    }
    if (errorMessage) {
      alert(errorMessage);
    }
  }

  // Total calculations
  useEffect(() => {
    let totalExclVat = 0;
    let totalInclVat = 0;

    itemsList.forEach((item) => {
      totalExclVat += parseFloat(item.ITEMRATE);
      totalInclVat += parseFloat(item.POITEMAMOUNT);
    });

    setAmountExclVat(totalExclVat); // Set total excluding VAT
    setAmountInclVat(totalInclVat); // Set total inclusive of VAT
    setVatAmount(totalInclVat - totalExclVat); // Set total VAT amount
  }, [itemsList]);

  // Fetching from Home Page
  // useEffect(() => {
  //   console.log(orderNo);
  //   if (orderNo) {
  //     axios
  //       .get(`${BASEURL}/getOrderHeaders?ENQUIRYNO=${orderNo}`, {
  //         headers: {
  //           "auth-token": authToken,
  //           "session-token": sessiontoken,
  //         },
  //       })
  //       .then((response) => {
  //         console.log(response.data);
  //         setOrderHeaders(response?.data);
  //         setSelClientCode(response?.data[0]?.CLIENTCODE);
  //         setSelclientEmail(response?.data[0]?.CLIENTEMAIL);
  //         setSelClientPhone(response?.data[0]?.PHONENUMBER);
  //         setSelClientCountry("");
  //         setSelClientCity("");
  //         setSelClientName(response?.data[0]?.["CLIENT NAME"]);
  //         setSelClientAddress(response?.data[0]?.["CLIENT ADDR1"]);
  //         setNewOrderNo(response?.data[0]?.ENQUIRYNO);
  //         setSelPayMode(response?.data[0]?.MODEOFPAY);
  //         setNotes(response?.data[0]?.PONOTES);
  //         setAmountExclVat(response?.data[0]?.POGROSSAMT);
  //         setAmountInclVat(response?.data[0]?.NETAMT);
  //         setVatAmount(response?.data[0]?.VAT);
  //         setCurrency(response?.data[0]?.POCURRENCY);
  //         getOrderItems(response?.data[0]?.ENQUIRYNO);
  //       })
  //       .catch((error) => {
  //         console.error(
  //           "Error fetching List Of Orders /getOrderHeaders:",
  //           error
  //         );
  //       });
  //   }
  // }, [orderNo]);

  if (isloading) {
    return <Loading />;
  }

  return (
    <>
      {!hideNavbar && <OrderTakerNavbarAllPAges />}
      {/* Header bar - now matches the dark navy title bar style from the POS page */}
      <header
        className="header__of__main"
        style={{ textAlign: "center", margin: "5px 0px" }}
      >
        <h1 className="header__of__page"> TAKE ORDER</h1>
      </header>
      <div className="w-full">
        <div className="w-full h-auto p-2">
          {/* Select Type */}

          <div className="lg:flex items-center justify-center gap-2 mb-2">
            <p className="text-red-600">Type Of Order :</p>
            <Select
              className="min-w-[288px] max-w-[288px]"
              onChange={(e) => {
                setSelType(e.value);
              }}
              value={
                selType
                  ? { label: selType, value: selType }
                  : { label: "Select Type", value: "" }
              }
              options={[
                { label: "Select Type", value: "" },
                { label: "SEATING", value: "SEATING" },
                { label: "TAKEAWAY", value: "TAKEAWAY" },
                { label: "DELIVERY", value: "DELIVERY" },
              ]}
            />
          </div>

          {/* 1st row */}
          <div className="lg:flex items-center gap-2">
            {selType && (
              <>
                <p className="text-red-600">Order No:</p>
                <input
                  className="w-16 h-8 rounded-md border border-black text-right pr-2 font-bold focus:outline-none focus:border-blue-500"
                  value={newOrderNo}
                  readOnly
                ></input>
                <button
                  className="flex items-center h-8 justify-center border border-black bg-[#002d62] text-white rounded-md px-3 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    setOrderPopUp(true);
                  }}
                >
                  ...
                </button>

                 <p className="text-red-600 ml-2">Customer:</p>
                <Select
                  className="w-56 text-sm"
                  onChange={(e) => {
                    if (e.value === "") {
                      setSelClientCode("");
                      setSelclientEmail("");
                      setSelClientPhone("");
                      setSelClientCountry("");
                      setSelClientCity("");
                      setSelClientName("");
                      setSelClientAddress("");
                    } else {
                      setSelClientCode("");
                      setSelclientEmail("");
                      setSelClientPhone("");
                      setSelClientCountry("");
                      setSelClientCity("");
                      setSelClientAddress("");
                      setSelClientName(e.value);
                      const selectedOption = clientsList?.find(
                        (obj) => obj["CLIENT NAME"] === e.value,
                      );
                      setSelClientCode(selectedOption?.["CLIENT CODE"]);
                      setSelclientEmail(selectedOption?.["EMAIL ADDRESS"]);
                      setSelClientPhone(selectedOption?.["MOBILE NO"]);
                      setSelClientCountry(selectedOption?.COUNTRY);
                      setSelClientCity(selectedOption?.CITY);
                      setSelClientAddress(selectedOption?.["ADDRESS 1"]);
                    }
                  }}
                  value={
                    selClientName
                      ? { label: selClientName, value: selClientName }
                      : { label: "Select Client", value: "" }
                  }
                  options={[
                    { label: "Select Client", value: "" }, // Empty option
                    ...clientsList?.map((item) => ({
                      label: item["CLIENT NAME"],
                      value: item["CLIENT NAME"],
                    })),
                  ]}
                />

                {selType === "SEATING" && (
                  <>
                    <p className="text-red-600 lg:ml-2">Area :</p>
                    <Select
                      className="w-40"
                      onChange={(e) => {
                        if (e.value !== "") { 
                          setSelAreaName(e.label);
                          setSelAreaId(e.value);
                          const tablesList = allTablesList?.filter((item) => item?.AREAID === e.value)
                          setTables(tablesList)
                        } else {
                          setSelAreaName(e.label);
                          setSelAreaId(e.value);
                        }
                      }}
                      value={
                        selAreaName
                          ? { label: selAreaName, value: selAreaName }
                          : { label: "Select Area", value: "" }
                      }
                      options={[
                        { label: "Select Area", value: "" }, // Empty option
                        ...areaList?.map((item) => ({
                          label: item.AREANAME,
                          value: item.AREAID,
                        })),
                      ]}
                    />
                    
                    <p className="text-red-600 lg:ml-2">Table:</p>
                    <Select
                      className="w-28"
                      onChange={(e) => {
                        setSelTable(e.value);
                      }}
                      value={
                        selTable
                          ? { label: selTable, value: selTable }
                          : { label: "Select Table", value: "" }
                      }
                      options={[
                        { label: "Select Table", value: "" }, // Empty option
                        ...tables?.map((item) => ({
                          label: item.TABLENUMBER,
                          value: item.TABLENUMBER,
                        })),
                      ]}
                    />
                  </>
                )}
               
                <button
                  className="flex items-center justify-center h-8 border border-black bg-[#002d62] text-white rounded-md px-4 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    if (!selClientName) {
                      alert("Kindly Supply Client Details");
                    }else if (selType === "SEATING" && !selAreaName) {
                      alert("Kindly Supply Area");
                    }else if (selType === "SEATING" && !selTable) {
                      alert("Kindly Supply Table Number");
                    }else {
                      setItemsPopUp(true);
                    }
                  }}
                >
                  Select Items
                </button>
                <button
                  className="flex items-center justify-center h-8 border border-black bg-red-950 text-white rounded-md px-4 hover:bg-red-900 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={() => {
                    window.location.reload();
                    //  setShowCashPos(true)
                  }}
                >
                  New Order
                </button>
              </>
            )}
          </div>

          {/* Order No PopUp */}
          {orderPopUp && (
            <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-black h-[500px] lg:w-[900px] p-1 overflow-y-auto w-[95%] rounded-md">
              <div className="lg:flex flex-row mt-2">
                <p className="text-red-600 ml-2">Search:</p>
                <input
                  className="w-64 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  type="text"
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                ></input>
                <p className="text-red-600 ml-2">Start Date:</p>
                <input
                  type="date"
                  className="w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setstartdate(e.target.value);
                  }}
                  value={startdate.split("T")[0]}
                ></input>
                <p className="text-red-600 ml-2">End Date:</p>
                <input
                  type="date"
                  className="w-36 h-8 border border-black ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
                  onChange={(e) => {
                    setEnddate(e.target.value);
                  }}
                  value={enddate.split("T")[0]}
                ></input>
              </div>
              <button
                className="absolute top-2 right-2 flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 ml-2 mr-2 bg-[#002e62dd] focus:outline-none focus:ring focus:border-blue-300"
                onClick={() => setOrderPopUp(false)}
              >
                Close
              </button>

              <aside className="table__pos__app text-sm ">
                <table class="custom-table">
                  <thead class="header-cell">
                    <tr>
                      <td className="pl-2">ORDER NO</td>
                      <td className="text-left">ORDER DATE</td>
                      <td className="text-left">CUSTOMER NAME</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filtOrders.map((row, index) => (
                      <tr
                        key={index}
                        onClick={() => {
                          setOrderPopUp(false);
                          setSelClientCode(row.CLIENTCODE);
                          setSelclientEmail(row.CLIENTEMAIL);
                          setSelClientPhone(row.PHONENUMBER);
                          setSelClientCountry("");
                          setSelClientCity("");
                          setSelClientName(row["CLIENT NAME"]);
                          setSelClientAddress(row["CLIENT ADDR1"]);
                          setNewOrderNo(row.ENQUIRYNO);
                          setSelPayMode(row.MODEOFPAY);
                          setNotes(row.PONOTES);
                          setAmountExclVat(row.POGROSSAMT);
                          setAmountInclVat(row.NETAMT);
                          setVatAmount(row.VAT);
                          setCurrency(row.POCURRENCY);
                          setSelTable(row.TABLENUMBER);
                          getOrderItems(row.ENQUIRYNO);
                        }}
                        className={
                          index < orderHeaders.length
                            ? "border-b cursor-pointer text-sm table-row"
                            : ""
                        }
                      >
                        <td className="text-right pr-12">
                          {row.ENQUIRYNO ? row.ENQUIRYNO : ""}
                        </td>
                        <td className="text-left">
                          {row.ENQUIRYDATE
                            ? moment(row.ENQUIRYDATE.split("T")[0]).format(
                                "DD/MM/YYYY",
                              )
                            : ""}
                        </td>
                        <td className="text-left">
                          {row["CLIENT NAME"] ? row["CLIENT NAME"] : ""}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </aside>
            </div>
          )}

          {/* Item Details */}
          {itemsPopup && (
            <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-black h-[78%] w-[95%] p-1 overflow-y-auto rounded-md">
              <div>
                <div className="w-auto flex flex-row">
                  {/* left side */}
                  <div className="w-[620px] flex flex-wrap overflow-y-auto max-h-[500px]">
                    {category.map((item, index) => (
                      <aside
                        key={index}
                        className={`rounded-md border border-black shadow-xl text-center p-2 ml-2 mt-2 cursor-pointer w-24 flex flex-col items-center ${
                          selcategory === item.MAINCATEGORY
                            ? "bg-[#002e62dd] text-white"
                            : "bg-white"
                        }`}
                        onClick={() => {
                          setistable(true);
                          getItemDetails(item.MAINCATEGORY);
                          setselcategory(item.MAINCATEGORY);
                        }}
                      >
                        {item.CATEGORYIMAGE?.data ? (
                          <>
                            {" "}
                            <img
                              className="text-amber-950"
                              src={URL.createObjectURL(
                                new Blob(
                                  [new Uint8Array(item.CATEGORYIMAGE?.data)],
                                  {
                                    type: "image/jpeg",
                                  },
                                ),
                              )}
                            />
                          </>
                        ) : (
                          <IoFastFoodOutline
                            size={50}
                            className={
                              selcategory === item.MAINCATEGORY
                                ? "text-white"
                                : "text-[#002e62]"
                            }
                          />
                        )}

                        <p className="text-xs">{item.MAINCATEGORY}</p>
                      </aside>
                    ))}
                  </div>

                  {/* right side */}

                  <div className="w-[800px] h-auto pb-2">
                    <div className="flex justify-end">
                      <IoClose
                        size={30}
                        className="text-[#002e62] cursor-pointer"
                        onClick={() => setItemsPopUp(false)}
                      />
                    </div>

                    {table ? (
                      <Loading />
                    ) : (
                      <div className="w-[620px] flex flex-wrap justify-around overflow-y-auto max-h-[500px]">
                        {itemdetails.map((item, index) => (
                          <aside
                            key={item.OM_ITEM_CODE}
                            className={`rounded-md border border-black shadow-xl text-center p-2 ml-2 mt-2 cursor-pointer w-36 flex flex-col items-center 
                        `}
                          >
                            {item.CATEGORYIMAGE?.data ? (
                              <>
                                {" "}
                                <img
                                  className="text-amber-950"
                                  src={URL.createObjectURL(
                                    new Blob(
                                      [
                                        new Uint8Array(
                                          item.CATEGORYIMAGE?.data,
                                        ),
                                      ],
                                      {
                                        type: "image/jpeg",
                                      },
                                    ),
                                  )}
                                />
                              </>
                            ) : (
                              <IoFastFoodOutline
                                size={50}
                                className="text-[#002e62]"
                              />
                            )}

                            <p className="text-xs font-bold">
                              {item.ITEMDESCRIPTION}
                            </p>
                            <div className="flex">
                              <span className="text-xs font-semibold text-red-600">
                                Item Code :
                              </span>
                              <p className="text-xs">{item.ITEMCODE}</p>
                            </div>
                            <div className="flex">
                              <span className="text-xs font-semibold text-red-600">
                                Stock Qty :
                              </span>
                              <p className="text-xs">{item.STOCKQTY}</p>
                            </div>
                            <div className="flex">
                              <span className="text-xs font-semibold text-red-600">
                                Rate :
                              </span>
                              <p className="text-xs">{item.ITEMRATE}</p>
                            </div>
                            {itemsList.some(
                              (value) =>
                                value.ITEMCODE === item.ITEMCODE &&
                                value.ITEMDESCRIPTION === item.ITEMDESCRIPTION,
                            ) ? (
                              <div className="border border-black rounded-md lg:flex justify-center items-center py-[2px] mt-2 px-[5px] mr-[10px] mb-[10px] ml-[10px] cursor-pointer text-white bg-green-700">
                                Added &nbsp; <FaCheck />
                              </div>
                            ) : (
                              <button
                                className="border border-black rounded-md flex justify-center items-center py-[2px] px-[5px] cursor-pointer text-white bg-[#002e62dd] m-[10px] focus:outline-none focus:ring focus:border-blue-300"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRowClick(item);
                                }}
                              >
                                Add &nbsp; <FaShoppingCart />
                              </button>
                            )}
                          </aside>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Selected Items */}
          {itemsList.length > 0 && (
            <>
              <aside className="my-4 text-sm overflow-auto">
                <table class="custom-table w-[98%]">
                  <thead class="header-cell">
                    <tr>
                      <td className="text-right">S NO</td>
                      <td className="text-left">ITEM CODE</td>
                      <td className="text-left">ITEM NAME</td>
                      <td className="text-right">QUANTITY</td>
                      <td className="text-left">SPICE LEVEL</td>
                      <td className="text-center">ACTION</td>
                      <td className="text-center">VIEW</td>
                    </tr>
                  </thead>
                  <tbody>
                    {itemsList?.map((item, index) => {
                      return (
                        <tr className="table-row cursor-pointer" key={index}>
                          <td className="text-right">{index + 1}</td>
                          <td className="text-left">{item.ITEMCODE}</td>
                          <td
                            className="text-left"
                            style={{ maxWidth: "200px" }}
                          >
                            {item.ITEMDESCRIPTION}
                          </td>
                          <td className="text-right pr-2">
                            {
                              <input
                                type="number"
                                className="w-20 h-8 border border-black rounded-md text-right pr-2 focus:outline-none focus:border-blue-500"
                                defaultValue={item.ITEMQTY ? item.ITEMQTY : ""}
                                onChange={(e) => {
                                  handleQuantityChange(item, e.target.value);
                                }}
                              ></input>
                            }
                          </td>
                          <td>
                            {
                              <Select
                                className="w-48"
                                value={
                                  item.PROPERTY
                                    ? {
                                        value: item.PROPERTY,
                                        label: item.PROPERTY,
                                      }
                                    : {
                                        value: "",
                                        label: "Select Spice Level",
                                      }
                                }
                                onChange={(selectedOption) =>
                                  handleSpiceLevelChange(
                                    item,
                                    selectedOption.value,
                                  )
                                }
                                options={[
                                  {
                                    value: "",
                                    label: "Select Spice Level",
                                  },
                                  {
                                    label: "MILD",
                                    value: "MILD",
                                  },
                                  {
                                    label: "MEDIUM SPICY",
                                    value: "MEDIUM SPICY",
                                  },
                                  {
                                    label: "HOT",
                                    value: "HOT",
                                  },
                                  {
                                    label: "VERY HOT",
                                    value: "VERY HOT",
                                  },
                                ]}
                                menuPortalTarget={document.body} // Render the dropdown menu in the body
                                styles={{
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                }} // Set a high z-index for the dropdown menu
                              ></Select>
                            }
                          </td>
                          <td>
                            <div className="lg:flex justify-center">
                              <MdDeleteForever
                                size={22}
                                className="text-red-600 cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRowClick(item);
                                }}
                              />
                            </div>
                          </td>
                          <td>
                            <div className="lg:flex justify-center">
                              <MdPreview
                                size={22}
                                className="text-[#002e62] cursor-pointer"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedItem(item);
                                  setViewPopUp(true);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </aside>

              <div className="w-full lg:flex items-center justify-center">
                <button
                  className="flex items-center justify-center h-8 border border-black bg-pink-600 rounded-md px-4 text-white hover:bg-pink-700 focus:outline-none focus:ring focus:border-blue-300"
                  onClick={async () => {
                    for (const item of itemsList) {
                      const quantity = item.ITEMQTY;
                      const spiceLevel = item.PROPERTY;

                      // Validate quantity for each selected item
                      if (!quantity || quantity <= 0) {
                        alert(
                          `Please ensure the quantity is provided for the item: ${item.OM_ITEM_DESCRIPTION}`,
                        );
                        return;
                      }

                      // Validate spice level for each selected item
                      if (!spiceLevel || spiceLevel === "") {
                        alert(
                          `Please ensure a spice level is selected for the item: ${item.OM_ITEM_DESCRIPTION}`,
                        );
                        return;
                      }
                    }
                    await SaveHeader();
                    await SaveDetails();
                    setShowCashPos(true)
                    // window.location.reload();
                  }}
                >
                  Place Order
                </button>
              </div>
            </>
          )}

          {/* DETAILED VIEW POPUP */}
          {viewPopUp && (
            <div className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 bg-white border border-black h-[65%] w-[75%] p-1 overflow-y-auto rounded-md">
              <div className="flex justify-end">
                <IoClose
                  size={30}
                  className="text-[#002e62] cursor-pointer"
                  onClick={() => {
                    setSelectedItem({});
                    setViewPopUp(false);
                  }}
                />
              </div>

              <div>
                {selectedItem && (
                  <div className="p-4 bg-white border border-black rounded-md">
                    <h2 className="text-2xl font-extrabold text-center mb-4 text-[#002e62]">
                      Selected Item Details
                    </h2>
                    <div className="flex justify-center items-center">
                      {selectedItem.IMAGENAME?.data ? (
                        <>
                          {" "}
                          <img
                            className="text-amber-950"
                            src={URL.createObjectURL(
                              new Blob(
                                [
                                  new Uint8Array(
                                    selectedItem.CATEGORYIMAGE?.data,
                                  ),
                                ],
                                {
                                  type: "image/jpeg",
                                },
                              ),
                            )}
                          />
                        </>
                      ) : (
                        <IoFastFoodOutline
                          size={50}
                          className="text-[#002e62]"
                        />
                      )}
                    </div>
                    {/*  */}
                    <div className="grid grid-cols-3 gap-4 mt-2">
                      <div>
                        <strong className="text-red-600">ITEM CODE:</strong>{" "}
                        {selectedItem.ITEMCODE || ""}
                      </div>
                      <div>
                        <strong className="text-red-600">ITEM NAME:</strong>{" "}
                        {selectedItem.ITEMDESCRIPTION || ""}
                      </div>
                      <div>
                        <strong className="text-red-600">SPICE LEVEL:</strong>{" "}
                        {selectedItem.PROPERTY || ""}
                      </div>
                      <div>
                        <strong className="text-red-600">UOM:</strong>{" "}
                        {selectedItem.ITEMUOM || ""}
                      </div>
                      <div>
                        <strong className="text-red-600">QTY ADDED:</strong>{" "}
                        {selectedItem.ITEMQTY || ""}
                      </div>
                      <div>
                        <strong className="text-red-600">ITEM RATE:</strong>{" "}
                        {selectedItem.ITEMRATE?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) || ""}
                      </div>
                      <div>
                        <strong className="text-red-600">
                          AMOUNT EXCL VAT:
                        </strong>{" "}
                        {selectedItem.ITEMRATE?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) || ""}
                      </div>
                      <div>
                        <strong className="text-red-600">
                          AMOUNT INCL VAT:
                        </strong>{" "}
                        {selectedItem.POITEMAMOUNT?.toLocaleString(undefined, {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2,
                        }) || ""}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>



        
         {showCashPos && (
                <div className="fixed top-0 left-1/2 -translate-x-1/2 bg-white border border-black lg:h-[calc(100vh-90px)] h-[calc(100vh-80px)] lg:w-[1200px] w-[95%] p-1 overflow-y-auto z-[500] rounded-md shadow-xl">
                  <CashPos
              hideNavbar={true}
              OrderNoToPass={newOrderNo}
                  />
        
                  <button
                    className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
                    onClick={() => setShowCashPos(false)}
                  >
                    Close
                  </button>
                </div>
              )}

      </div>
    </>
  );
};

export default TakeOrder;
